import React from 'react';
import NewCourtScheduler from '../business/BusinessCourtReservations';
import { useAuth } from '../contexts/AuthContext';

const StaffCourtReservations: React.FC = () => {
  const { user } = useAuth();

  if (!user?.facilityId || !user?.businessId) {
    return <div>No facility assigned. Please contact your administrator.</div>;
  }

  return (
    <div className="staff-court-reservations">
      <NewCourtScheduler facilityId={user.facilityId} businessId={user.businessId} />
    </div>
  );
};

export default StaffCourtReservations; 